import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import HelmetWrapper from 'components/HelmetWrapper';
import AuthContext from 'providers/Auth/Auth.context';

const SellerRouter: React.FC = () => {
  const { latestActivityMetricsLocation, updateLatestActivityMetricsLocation } =
    useContext(AuthContext);

  useEffect(() => {
    return () => {
      if (latestActivityMetricsLocation)
        updateLatestActivityMetricsLocation(null);
    };
  }, [latestActivityMetricsLocation, updateLatestActivityMetricsLocation]);

  return (
    <>
      <HelmetWrapper title="Selling portfolio" />
      <Outlet />
    </>
  );
};

export default SellerRouter;
